import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M9.558 9.058a.626.626 0 0 1 .884.884L8.385 12l2.057 2.058a.626.626 0 0 1-.884.884l-2.5-2.5a.626.626 0 0 1 0-.884l2.5-2.5Zm4.167 0a.626.626 0 0 1 .883 0l2.5 2.5a.626.626 0 0 1 0 .884l-2.5 2.5a.625.625 0 0 1-.883-.884L15.782 12l-2.057-2.058a.626.626 0 0 1 0-.884Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M16.2 3c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.31 1.31C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.31 1.31C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.31-1.31C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.31-1.31C5.28 3 6.12 3 7.8 3h8.4ZM7.8 4.2c-.86 0-1.432.001-1.872.037-.426.035-.622.097-.745.16a1.8 1.8 0 0 0-.787.786c-.062.123-.124.319-.159.745C4.201 6.368 4.2 6.94 4.2 7.8v8.4c0 .86.001 1.432.037 1.872.035.426.097.622.16.745a1.8 1.8 0 0 0 .786.787c.123.062.319.124.745.159.44.036 1.012.037 1.872.037h8.4c.86 0 1.432-.001 1.872-.037.426-.035.622-.097.745-.16.339-.172.614-.447.787-.786.062-.123.124-.319.159-.745.036-.44.037-1.012.037-1.872V7.8c0-.86-.001-1.432-.037-1.872-.035-.426-.097-.622-.16-.745a1.8 1.8 0 0 0-.786-.787c-.123-.062-.319-.124-.745-.159-.44-.036-1.012-.037-1.872-.037H7.8Z"
      clip-rule="evenodd"
    />
  </svg>
`;
